"use client";

import { c as _c } from "react/compiler-runtime";
import { useLinkPreviewVariant } from "./LinkPreviewContext";
import { LinkPreviewCardLayout } from "./OpenGraphPreview";
import MarketplaceCompactCta from "./marketplace/MarketplaceCompactCta";
import MarketplaceFullFooter from "./marketplace/MarketplaceFullFooter";
import MarketplaceItemPreviewMediaLink from "./marketplace/MarketplaceItemPreviewMediaLink";
import { DEFAULT_MARKETPLACE_TITLE } from "./marketplace/MarketplaceItemPreviewCard.constants";
import type { MarketplaceItemPreviewCardProps } from "./marketplace/MarketplaceItemPreviewCard.types";
import { buildMarketplaceCtaLabel, getMarketplaceBrand, resolvePreviewHref } from "./marketplace/MarketplaceItemPreviewCard.utils";
import MarketplaceOverlayActionButtons from "./marketplace/MarketplaceOverlayActionButtons";
import { getMarketplaceContainerClass } from "./marketplace/previewLayout";
export default function MarketplaceItemPreviewCard(t0) {
  const $ = _c(63);
  const {
    href,
    mediaUrl,
    mediaMimeType,
    price,
    title,
    compact: t1,
    hideActions: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const hideActions = t2 === undefined ? false : t2;
  const variant = useLinkPreviewVariant();
  let t3;
  if ($[0] !== href) {
    t3 = resolvePreviewHref(href);
    $[0] = href;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const resolvedPreviewHref = t3;
  let displayTitle;
  let hasPrice;
  let marketplaceBrand;
  let normalizedPrice;
  let t4;
  if ($[2] !== href || $[3] !== price || $[4] !== title) {
    normalizedPrice = typeof price === "string" ? price.trim() : "";
    let t5;
    if ($[10] !== title) {
      t5 = typeof title === "string" ? title.trim() : "";
      $[10] = title;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    const normalizedTitle = t5;
    hasPrice = normalizedPrice.length > 0;
    const hasTitle = normalizedTitle.length > 0;
    displayTitle = hasTitle ? normalizedTitle : DEFAULT_MARKETPLACE_TITLE;
    marketplaceBrand = getMarketplaceBrand(href);
    t4 = buildMarketplaceCtaLabel({
      normalizedPrice,
      marketplaceBrand
    });
    $[2] = href;
    $[3] = price;
    $[4] = title;
    $[5] = displayTitle;
    $[6] = hasPrice;
    $[7] = marketplaceBrand;
    $[8] = normalizedPrice;
    $[9] = t4;
  } else {
    displayTitle = $[5];
    hasPrice = $[6];
    marketplaceBrand = $[7];
    normalizedPrice = $[8];
    t4 = $[9];
  }
  const ctaAriaLabel = t4;
  if (compact) {
    let t5;
    if ($[12] !== compact || $[13] !== variant) {
      t5 = getMarketplaceContainerClass(variant, compact);
      $[12] = compact;
      $[13] = variant;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    const t6 = `${t5} tw-relative`;
    let t7;
    if ($[15] !== mediaMimeType || $[16] !== mediaUrl || $[17] !== resolvedPreviewHref) {
      t7 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
      $[15] = mediaMimeType;
      $[16] = mediaUrl;
      $[17] = resolvedPreviewHref;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== ctaAriaLabel || $[20] !== hasPrice || $[21] !== hideActions || $[22] !== marketplaceBrand || $[23] !== normalizedPrice || $[24] !== resolvedPreviewHref) {
      t8 = <MarketplaceCompactCta resolvedPreviewHref={resolvedPreviewHref} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} normalizedPrice={normalizedPrice} marketplaceBrand={marketplaceBrand} />;
      $[19] = ctaAriaLabel;
      $[20] = hasPrice;
      $[21] = hideActions;
      $[22] = marketplaceBrand;
      $[23] = normalizedPrice;
      $[24] = resolvedPreviewHref;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    let t9;
    if ($[26] !== hideActions || $[27] !== href || $[28] !== resolvedPreviewHref) {
      t9 = !hideActions && <MarketplaceOverlayActionButtons href={href} resolvedPreviewHref={resolvedPreviewHref} />;
      $[26] = hideActions;
      $[27] = href;
      $[28] = resolvedPreviewHref;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    let t10;
    if ($[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
      t10 = <div className={t6} data-testid="manifold-item-card">{t7}{t8}{t9}</div>;
      $[30] = t6;
      $[31] = t7;
      $[32] = t8;
      $[33] = t9;
      $[34] = t10;
    } else {
      t10 = $[34];
    }
    let t11;
    if ($[35] !== href || $[36] !== t10 || $[37] !== variant) {
      t11 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t10}</LinkPreviewCardLayout>;
      $[35] = href;
      $[36] = t10;
      $[37] = variant;
      $[38] = t11;
    } else {
      t11 = $[38];
    }
    return t11;
  }
  let t5;
  if ($[39] !== compact || $[40] !== variant) {
    t5 = getMarketplaceContainerClass(variant, compact);
    $[39] = compact;
    $[40] = variant;
    $[41] = t5;
  } else {
    t5 = $[41];
  }
  const t6 = `${t5} tw-relative`;
  let t7;
  if ($[42] !== mediaMimeType || $[43] !== mediaUrl || $[44] !== resolvedPreviewHref) {
    t7 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
    $[42] = mediaMimeType;
    $[43] = mediaUrl;
    $[44] = resolvedPreviewHref;
    $[45] = t7;
  } else {
    t7 = $[45];
  }
  let t8;
  if ($[46] !== ctaAriaLabel || $[47] !== displayTitle || $[48] !== hasPrice || $[49] !== hideActions || $[50] !== href || $[51] !== marketplaceBrand || $[52] !== normalizedPrice || $[53] !== resolvedPreviewHref) {
    t8 = <MarketplaceFullFooter href={href} resolvedPreviewHref={resolvedPreviewHref} displayTitle={displayTitle} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} normalizedPrice={normalizedPrice} marketplaceBrand={marketplaceBrand} />;
    $[46] = ctaAriaLabel;
    $[47] = displayTitle;
    $[48] = hasPrice;
    $[49] = hideActions;
    $[50] = href;
    $[51] = marketplaceBrand;
    $[52] = normalizedPrice;
    $[53] = resolvedPreviewHref;
    $[54] = t8;
  } else {
    t8 = $[54];
  }
  let t9;
  if ($[55] !== t6 || $[56] !== t7 || $[57] !== t8) {
    t9 = <div className={t6} data-testid="manifold-item-card">{t7}{t8}</div>;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
  } else {
    t9 = $[58];
  }
  let t10;
  if ($[59] !== href || $[60] !== t9 || $[61] !== variant) {
    t10 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t9}</LinkPreviewCardLayout>;
    $[59] = href;
    $[60] = t9;
    $[61] = variant;
    $[62] = t10;
  } else {
    t10 = $[62];
  }
  return t10;
}